import { useState } from "#app";

export const useImagePreview = () => {
  const isImagePreviewOpen = useState("isImagePreviewOpen", () => false);
  const imagePreviewSrc = useState("imagePreviewSrc", () => "");
  const imagePreviewCompare = useState("imagePreviewCompare", () => null);

  /** @param {string} src 图片或视频 URL（视频由 GlobalImagePreview 按扩展名识别） */
  const openImagePreview = (src) => {
    if (!src) {
      return;
    }
    imagePreviewCompare.value = null;
    imagePreviewSrc.value = src;
    isImagePreviewOpen.value = true;
  };

  const openComparePreview = (compare) => {
    if (!compare?.leftImage || !compare?.rightImage) {
      return;
    }
    imagePreviewSrc.value = "";
    imagePreviewCompare.value = {
      leftImage: compare.leftImage,
      rightImage: compare.rightImage,
      initialPosition:
        typeof compare.initialPosition === "number"
          ? compare.initialPosition
          : 50,
    };
    isImagePreviewOpen.value = true;
  };

  const closeImagePreview = () => {
    isImagePreviewOpen.value = false;
    imagePreviewSrc.value = "";
    imagePreviewCompare.value = null;
  };

  return {
    isImagePreviewOpen,
    imagePreviewSrc,
    imagePreviewCompare,
    openImagePreview,
    openComparePreview,
    closeImagePreview,
  };
};
